<script>
export default {
  props: ["clr"]
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <path
      d="M29.5083 23.0381C30.7937 24.1942 31.6609 25.7423 31.9751 27.4417C32.2893 29.1411 32.0328 30.8967 31.2455 32.4354C35.426 25.4574 33.8457 19.9692 33.8457 19.9692C24.7675 15.4217 19.668 19.2971 19.668 19.2971C23.2981 19.2855 26.8038 20.6183 29.5083 23.0381Z"
      :fill="clr"
    />
    <path
      d="M19.2316 24.5381C20.373 23.2454 21.9141 22.3713 23.6099 22.0547C25.3056 21.7381 27.0586 21.9972 28.59 22.7908C21.6413 18.5906 16.1831 20.1699 16.1831 20.1699C11.7 29.2984 15.5107 34.417 15.5107 34.417C15.4956 30.7792 16.82 27.263 19.2316 24.5381Z"
      :fill="clr"
    />
    <path
      d="M20.8464 34.7084C19.5617 33.5544 18.6939 32.009 18.3778 30.3119C18.0617 28.6148 18.3148 26.8609 19.098 25.3223C14.9399 32.289 16.509 37.7885 16.509 37.7885C25.5872 42.336 30.6755 38.4606 30.6755 38.4606C27.0474 38.4685 23.5453 37.1315 20.8464 34.7084Z"
      :fill="clr"
    />
    <path
      d="M34.888 23.3066C34.9021 26.9463 33.5733 30.4634 31.1558 33.1856C30.0162 34.4773 28.4771 35.351 26.7833 35.6677C25.0894 35.9843 23.3383 35.7256 21.8086 34.9329C28.7461 39.1331 34.2155 37.5426 34.2155 37.5426C38.7434 28.4253 34.888 23.3066 34.888 23.3066Z"
      :fill="clr"
    />
    <path
      d="M31.6612 10C25.172 10.1232 24.7461 15.7907 24.7461 15.7907C31.269 16.3395 31.6612 10 31.6612 10Z"
      :fill="clr"
    />
    <rect x="0.5" y="0.5" width="49" height="49" rx="3.5" :stroke="clr" />
  </svg>
</template>
